export const LANGUAGES = [
  { code: "hi", label: "हिन्दी", short: "हि" },
  { code: "en", label: "English", short: "EN" },
];

// UI strings — English & Hindi. Content (titles, bodies) is bilingual from the DB.
export const STRINGS = {
  en: {
    nav_kathas: "Kathas",
    nav_mantras: "Mantras",
    nav_puja: "Pooja Vidhi",
    nav_vedic: "Vedic Knowledge",
    nav_stotras: "Stotras",
    nav_festivals: "Festivals",
    nav_glossary: "Glossary",
    nav_about: "About",
    search_placeholder: "Search mantras, kathas, pooja vidhi, festivals…",
    explore_knowledge: "Explore Knowledge",
    begin_katha: "Begin with a Katha",
    hero_headline: "Explore the Knowledge Traditions of Bharat.",
    hero_support: "Kathas, mantras, pooja vidhi, Vedic knowledge and traditional practices — organised and explained for easier access in the digital age.",
    explore_dharmartha: "Explore Dharmartha",
    featured_knowledge: "Featured Knowledge",
    recently_added: "Recently Added",
    explore_glossary: "Explore the Glossary",
    about_dharmartha: "About Dharmartha",
    read: "Read",
    listen: "Listen",
    meaning: "Meaning",
    read_time: "read",
    view_all: "View all",
    related: "Related Knowledge",
    sources: "Sources & References",
    bookmark: "Bookmark",
    bookmarked: "Bookmarked",
    share: "Share",
    bookmarks: "Bookmarks",
    no_results: "No entries found.",
    all: "All",
    filters: "Filters",
    clear: "Clear",
    // Homepage sections
    explore_overline: "Reverence · Knowledge · Tradition",
    explore_desc: "Carefully organised gateways into Bharat's living knowledge traditions.",
    spotlight_overline: "Today's spotlight",
    spotlight_title: "In focus today",
    spotlight_desc: "A fresh reading each day from the living tradition.",
    temples_overline: "Temples of Bharat",
    temples_title: "Sacred temples across the land",
    quiz_overline: "Dharma Quiz",
    quiz_title: "Test your knowledge of Dharma",
    quiz_desc: "Ten questions on mantras, suktas, festivals and the temples of Bharat. How much do you know?",
    quiz_cta: "Start the quiz",
    featured_overline: "Editorially selected",
    services_overline: "Reverence · Service",
    services_title: "Services",
    services_desc: "Request a pooja, homam or yagya, or a Jyotisha, numerology, vastu, Panchangam or Muhurta consultation — offered with care and respect for tradition.",
    glossary_overline: "Discovery",
    glossary_desc: "Understand the Sanskrit and Bharatiya terms that recur across the tradition.",
    recent_overline: "Fresh from the editorial desk",
    about_title: "Ancient knowledge, thoughtfully organised for the digital age.",
    about_body: "A vast body of Bharatiya knowledge exists across texts, traditions, oral practices and regional sources, but much of it remains difficult to discover or access digitally. Dharmartha exists to help organise and present this knowledge in an accessible, respectful digital format.",
    about_cta: "Why Dharmartha?",
    // Filters
    filter_deity: "Deity",
    filter_tradition: "Tradition",
    filter_purpose: "Purpose",
    filter_occasion: "Occasion",
    filter_category: "Category",
    // Hub
    related_on: "Related on Dharmartha",
    texts_attributed: "Texts traditionally attributed",
    entry_not_found: "Entry not found.",
    text_one: "text",
    text_many: "texts",
  },
  hi: {
    nav_kathas: "कथाएँ",
    nav_mantras: "मंत्र",
    nav_puja: "पूजा विधि",
    nav_vedic: "वैदिक ज्ञान",
    nav_stotras: "स्तोत्र",
    nav_festivals: "पर्व",
    nav_glossary: "शब्दकोश",
    nav_about: "परिचय",
    search_placeholder: "मंत्र, कथा, पूजा विधि, पर्व खोजें…",
    explore_knowledge: "ज्ञान देखें",
    begin_katha: "एक कथा से आरंभ करें",
    hero_headline: "भारत की ज्ञान परंपराओं का अन्वेषण करें।",
    hero_support: "कथाएँ, मंत्र, पूजा विधि, वैदिक ज्ञान एवं परंपरागत प्रथाएँ — डिजिटल युग में सहज पहुँच हेतु व्यवस्थित एवं व्याख्यायित।",
    explore_dharmartha: "धर्मार्थ का अन्वेषण",
    featured_knowledge: "चयनित ज्ञान",
    recently_added: "हाल में जोड़ा गया",
    explore_glossary: "शब्दकोश देखें",
    about_dharmartha: "धर्मार्थ के विषय में",
    read: "पढ़ें",
    listen: "सुनें",
    meaning: "अर्थ",
    read_time: "पठन",
    view_all: "सभी देखें",
    related: "संबंधित ज्ञान",
    sources: "स्रोत एवं संदर्भ",
    bookmark: "सहेजें",
    bookmarked: "सहेजा गया",
    share: "साझा करें",
    bookmarks: "सहेजे गए",
    no_results: "कोई प्रविष्टि नहीं मिली।",
    all: "सभी",
    filters: "छाँटें",
    clear: "हटाएँ",
    // Homepage sections
    explore_overline: "श्रद्धा · ज्ञान · परंपरा",
    explore_desc: "भारत की जीवंत ज्ञान परंपराओं में सुव्यवस्थित प्रवेश-द्वार।",
    spotlight_overline: "आज का चयन",
    spotlight_title: "आज विशेष",
    spotlight_desc: "जीवंत परंपरा से प्रतिदिन एक नवीन पठन।",
    temples_overline: "भारत के मंदिर",
    temples_title: "देश भर के पावन मंदिर",
    quiz_overline: "धर्म प्रश्नोत्तरी",
    quiz_title: "अपना धर्म-ज्ञान परखें",
    quiz_desc: "मंत्र, सूक्त, पर्व एवं भारत के मंदिरों पर दस प्रश्न। आप कितना जानते हैं?",
    quiz_cta: "प्रश्नोत्तरी आरम्भ करें",
    featured_overline: "संपादकीय चयन",
    services_overline: "श्रद्धा · सेवा",
    services_title: "सेवाएँ",
    services_desc: "पूजा, होम अथवा यज्ञ, या ज्योतिष, अंक ज्योतिष, वास्तु, पंचांग अथवा मुहूर्त परामर्श का अनुरोध करें — परंपरा के प्रति श्रद्धा एवं सावधानी से प्रस्तुत।",
    glossary_overline: "खोज",
    glossary_desc: "परंपरा में बार-बार आने वाले संस्कृत एवं भारतीय शब्दों को समझें।",
    recent_overline: "संपादकीय मेज़ से नवीनतम",
    about_title: "प्राचीन ज्ञान, डिजिटल युग हेतु विचारपूर्वक व्यवस्थित।",
    about_body: "भारतीय ज्ञान का विशाल भंडार ग्रंथों, परंपराओं, मौखिक प्रथाओं एवं क्षेत्रीय स्रोतों में विद्यमान है, किंतु इसका अधिकांश भाग डिजिटल रूप में खोजना या प्राप्त करना कठिन है। धर्मार्थ इस ज्ञान को सुलभ एवं सम्मानजनक डिजिटल स्वरूप में व्यवस्थित एवं प्रस्तुत करने हेतु समर्पित है।",
    about_cta: "धर्मार्थ क्यों?",
    // Filters
    filter_deity: "देवता",
    filter_tradition: "परंपरा",
    filter_purpose: "उद्देश्य",
    filter_occasion: "अवसर",
    filter_category: "श्रेणी",
    // Hub
    related_on: "धर्मार्थ पर संबंधित",
    texts_attributed: "परंपरागत रूप से संबद्ध ग्रंथ",
    entry_not_found: "प्रविष्टि नहीं मिली।",
    text_one: "ग्रंथ",
    text_many: "ग्रंथ",
  },
};
